import * as React from 'react'

import {
  IconButton,
  Badge
} from '@mui/material'

import PropTypes, { InferProps } from 'prop-types'

/**
 * @function NavBarIconButtonBadge
 * @description Boton con icono y badgage numero o punto.
 * @param {Element} elementIcon: Icon to display.
 * @param {number} numBadge: Number to diaplay.
 * @param {boolean} isDot: Display number or dot.
 * @param {function} fncAction: Function click event.
 * @returns {React.JSX.Element}
 * @example
 * <NavBarIconButtonBadge elementIcon={<QuestionAnswerIcon />} numBadge={17} isDot={true} />
 * <NavBarIconButtonBadge elementIcon={<SettingsIcon />} numBadge={1} fncAction={ ()=>{ alert("Typography"); } } />
 */
function NavBarIconButtonBadge({ elementIcon, numBadge, isDot, fncAction }: InferProps<typeof NavBarIconButtonBadge.propTypes>): React.JSX.Element {
  return (
    <IconButton
      size="large"
      aria-label={isNaN(numBadge) ? `show ${numBadge} new notifications` : 'Notifications'}
      color="inherit"
      sx={{ mr: { xs: 0.875, md: 1} }}
      onClick={
        (event: React.SyntheticEvent) => {
          event.preventDefault();
          !(fncAction == null) && fncAction()
        }
      }
    >
      {
        isDot !== true
          ? (
            <Badge color="primary" variant="dot" invisible={numBadge > 0} >
              {elementIcon}
            </Badge>
          )
          : (
            <Badge
              badgeContent={numBadge}
              sx={{ '& .MuiBadge-badge': { backgroundColor: '#e53935', color: '#000000' } }}
            >
              {elementIcon}
            </Badge>
          )
      }
    </IconButton>
  )
}

NavBarIconButtonBadge.propTypes = {
  elementIcon: PropTypes.element.isRequired,
  numBadge: PropTypes.number.isRequired,
  isDot: PropTypes.bool,
  fncAction: PropTypes.func
}

export default NavBarIconButtonBadge
